import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { LoadingModule } from '../../../../shared/ui/loading/loading.module'
import { DirectivesUpgradedModule } from '../../../../shared/directives/directivesUpgraded.module'
import { AddLinkAttachmentDialogComponent } from './add-link-attachment-dialog.component'

@NgModule({
    declarations: [AddLinkAttachmentDialogComponent],
    exports: [AddLinkAttachmentDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        LoadingModule,
        DirectivesUpgradedModule,
    ],
})
export class AddLinkAttachmentDialogModule {}
